/**
 * Formatiert ein Datum in deutsches Format (DD.MM.YYYY)
 */
export function formatDate(dateString) {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  return date.toLocaleDateString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
}

/**
 * Formatiert ein Datum mit Uhrzeit (DD.MM.YYYY, HH:MM)
 */
export function formatDateTime(dateString) {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  return date.toLocaleDateString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

/**
 * Berechnet die vergangene Zeit seit einem Datum in menschenlesbarer Form
 */
export function timeAgo(dateString) {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  const now = new Date();
  const seconds = Math.floor((now - date) / 1000);
  
  if (seconds < 60) {
    return 'Gerade eben';
  } else if (seconds < 3600) {
    const minutes = Math.floor(seconds / 60);
    return `Vor ${minutes} Minute${minutes > 1 ? 'n' : ''}`;
  } else if (seconds < 86400) {
    const hours = Math.floor(seconds / 3600);
    return `Vor ${hours} Stunde${hours > 1 ? 'n' : ''}`;
  } else if (seconds < 2592000) {
    const days = Math.floor(seconds / 86400);
    return `Vor ${days} Tag${days > 1 ? 'en' : ''}`;
  } else {
    return formatDate(dateString);
  }
}

/**
 * Formatiert ein Datum für die Anzeige in einem Formular (YYYY-MM-DD)
 */
export function formatForInput(dateString) {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  
  return `${year}-${month}-${day}`;
} 